<div class="pusher" id="MainContaier">
  <div id="SecondaryContainer">
    <div style="margin: 10px">
      <!-- Progress Bar      -->
      <div [hidden]="!graphicHidden" style="margin-bottom: 10px">
        <p-progressBar mode="indeterminate"></p-progressBar>
      </div>
      <!-- Resource DropDown    -->
      <div class="dropDowns">
        <div>
          <h4>Select Resource</h4>
        </div>
        <div class="floatRight">
          <p-dropdown
            [(ngModel)]="resource"
            [options]="resources"
            (onChange)="resourceSelected(dt)"
            [style]="{ width: '160px' }"
            placeholder="Select Resource"
          >
          </p-dropdown>
        </div>
      </div>
      <!-- Location DropDown -->
      <div>
        <!-- Option buttons -->
        <div style="float: right" class="fullfilters">
          <button
            (click)="onFilterButtonClick()"
            icon="fa-filter"
            iconPos="left"
            label="{{ filters }}"
            pButton
            type="button"
          ></button>
          <button
            (click)="dt.exportCSV()"
            icon="fa-file-o"
            iconPos="left"
            label="Export to CSV"
            pButton
            type="button"
          ></button>
          <button
            (click)="onReloadTable(dt)"
            icon="fa-refresh"
            iconPos="left"
            label="Refresh ({{ display }})"
            pButton
          ></button>
        </div>
        <div style="float: right" class="shortfilters">
          <button
            (click)="onFilterButtonClick()"
            icon="fa-filter"
            iconPos="left"
            pButton
            type="button"
          ></button>
          <button
            (click)="dt.exportCSV()"
            icon="fa-file-o"
            iconPos="left"
            pButton
            type="button"
          ></button>
          <button
            (click)="onReloadTable(dt)"
            icon="fa-refresh"
            iconPos="left"
            label="({{ display }})"
            pButton
          ></button>
        </div>
        <!-- Table Area -->
        <div>
          <h3>Active Job Dashboard</h3>
          <p-table
            #dt
            (onRowSelect)="goDetails($event)"
            [(selection)]="selectedJob"
            [columns]="cols"
            [paginator]="true"
            [rowHover]="true"
            [rowsPerPageOptions]="[10, 20, 30, 50]"
            [rows]="10"
            [value]="activeJobs"
            [loading]="loading"
            styleClass="text-center"
          >
            <ng-template let-columns pTemplate="header">
              <tr>
                <th
                  *ngFor="let col of cols; let i = index"
                  [ngStyle]="{ width: col.width }"
                  [ngSwitch]="col.field"
                  class="priority-{{ i + 1 }}"
                  id="{{ i + 1 }}"
                >
                  <span>{{ col.header }}</span>
                  <input
                    *ngSwitchCase="'name'"
                    pInputText
                    type="text"
                    (input)="
                      listJobNames();
                      dt.filter(selectedJobName, 'jobName', 'contains')
                    "
                    [(ngModel)]="selectedJobName"
                    [hidden]="isFilterApp"
                    defaultLabel="Choose job name"
                    [style]="{ width: '100%' }"
                    filter="true"
                  />
                  <!-- Job User Filter-->
                  <input
                    *ngSwitchCase="'jobUser'"
                    pInputText
                    type="text"
                    (input)="
                      listJobUsers();
                      dt.filter(selectedJobUser, 'jobUser', 'contains')
                    "
                    [(ngModel)]="selectedJobUser"
                    [hidden]="isFilterApp"
                    defaultLabel="Choose job user"
                    [style]="{ width: '100%' }"
                    filter="true"
                  />
                  <!-- Job Number Filter-->
                  <input
                    *ngSwitchCase="'jobNumber'"
                    pInputText
                    type="text"
                    (input)="
                      listJobNumbers();
                      dt.filter(selectedJobNumber, 'jobNumber', 'contains')
                    "
                    [(ngModel)]="selectedJobNumber"
                    [hidden]="isFilterApp"
                    defaultLabel="Choose job number"
                    [style]="{ width: '100%' }"
                    filter="true"
                  />
                  <!-- AuthName Filter-->
                  <input
                    *ngSwitchCase="'authName'"
                    pInputText
                    type="text"
                    (input)="
                      listAuthNames();
                      dt.filter(
                        selectedAuthName,
                        'authorizationName',
                        'contains'
                      )
                    "
                    [(ngModel)]="selectedAuthName"
                    [hidden]="isFilterApp"
                    defaultLabel="Choose AuthName"
                    [style]="{ width: '100%' }"
                    filter="true"
                  />
                  <!-- SubSystem Filter-->
                  <p-multiSelect
                    #mss
                    (onChange)="
                      listSubSystems();
                      dt.filter(selectedSubSystem, 'subSystem', 'in')
                    "
                    *ngSwitchCase="'subSystem'"
                    [(ngModel)]="selectedSubSystem"
                    [hidden]="isFilterApp"
                    [options]="subSystemsOptions"
                    [style]="{ width: '100%', height: '100%' }"
                    id="rembold"
                    showToggleAll="false"
                    styleClass="multi"
                  >
                  </p-multiSelect>
                  <!-- Status Filter -->
                  <p-multiSelect
                    #ms
                    (onChange)="
                      listJobStatus();
                      dt.filter(selectedStatus, 'jobStatus', 'in')
                    "
                    *ngSwitchCase="'status'"
                    [(ngModel)]="selectedStatus"
                    [hidden]="isFilterApp"
                    [options]="statusOptions"
                    [style]="{ width: '100%', height: '100%' }"
                    id="rembold"
                    showToggleAll="false"
                    styleClass="multi"
                  >
                  </p-multiSelect>
                  <!-- System Filter -->
                  <p-multiSelect
                    #mst
                    (onChange)="
                      listSystems(); dt.filter(selectedSystem, 'system', 'in')
                    "
                    *ngSwitchCase="'system'"
                    [(ngModel)]="selectedSystem"
                    [hidden]="isFilterApp"
                    [options]="systemsOptions"
                    [style]="{ width: '100%', height: '100%' }"
                    id="rembold"
                    showToggleAll="false"
                    styleClass="multi"
                  >
                  </p-multiSelect>
                </th>
              </tr>
            </ng-template>
            <ng-template let-columns="cols" let-rowData pTemplate="body">
              <tr>
                <td
                  *ngFor="let col of cols; let i = index"
                  class="priority-{{ i + 1 }}"
                >
                  <!-- Job Name Column   -->
                  <span *ngIf="col.field === 'name'">{{
                    rowData["jobName"]
                  }}</span>
                  <span *ngIf="col.field === 'jobUser'">{{
                    rowData["jobUser"]
                  }}</span>
                  <span *ngIf="col.field === 'jobNumber'">{{
                    rowData["jobNumber"]
                  }}</span>
                  <!-- Job Status  Column -->
                  <div
                    [style.background]="
                      rowData['jobStatus'] === 'LCKW' ||
                      rowData['jobStatus'] === 'MSGW'
                        ? 'indianred'
                        : null
                    "
                    [style.color]="
                      rowData['jobStatus'] === 'LCKW' ||
                      rowData['jobStatus'] === 'MSGW'
                        ? 'white'
                        : null
                    "
                  >
                    <span *ngIf="col.field === 'status'"
                      >{{ !rowData["jobStatus"] ? "--" : rowData["jobStatus"] }}
                      <i
                        [ngClass]="statusIconHandler(rowData['jobStatus'])"
                      ></i>
                    </span>
                  </div>
                  <span *ngIf="col.field === 'authName'">{{
                    !rowData["authorizationName"]
                      ? "--"
                      : rowData["authorizationName"]
                  }}</span>
                  <!-- Subsystem Column -->
                  <span *ngIf="col.field === 'subSystem'">{{
                    !rowData["subSystem"] ? "--" : rowData["subSystem"]
                  }}</span>
                  <!-- Percentage Column -->
                  <span *ngIf="col.field === 'percentage'">{{
                    !rowData["percent"] ? "--" : rowData["percent"]
                  }}</span>
                  <!-- System Column -->
                  <span *ngIf="col.field === 'system'">{{
                    !rowData["system"] ? "--" : rowData["system"]
                  }}</span>
                  <span *ngIf="col.field === 'action'" class="priority-1">
                    <button
                      icon="fa-external-link"
                      iconPos="left"
                      (click)="showJobLogs(rowData)"
                      label="View Log"
                      pButton
                      type="button"
                      *ngIf="
                        rowData['showLog'] == 'Y' || rowData['showLog'] == 'y'
                      "
                      [disabled]="
                        rowData['showLog'] == 'N' || rowData['showLog'] == 'n'
                      "
                      class="fullfilters"
                    ></button>
                    <button
                      icon="fa-external-link"
                      iconPos="left"
                      (click)="showJobLogs(rowData)"
                      pButton
                      type="button"
                      *ngIf="
                        rowData['showLog'] == 'Y' || rowData['showLog'] == 'y'
                      "
                      [disabled]="
                        rowData['showLog'] == 'N' || rowData['showLog'] == 'n'
                      "
                      class="shortfilters"
                    ></button>
                  </span>
                </td>
              </tr>
            </ng-template>
            <ng-template pTemplate="emptymessage" let-columns>
              <ng-container>
                <tr>
                  <td [attr.colspan]="cols.length">
                    <h3 style="padding-top: 1%">
                      No Active Jobs found for this filter selection.
                    </h3>
                  </td>
                </tr>
              </ng-container>
            </ng-template>
          </p-table>
        </div>
      </div>
    </div>
  </div>
  <p-dialog
    [(visible)]="logdisplay"
    appendTo="body"
    color="primary"
    header="Job Log"
    modal="true"
  >
    <div modal="false">
      <div class="container-all" style="margin: 10px">
        <div style="margin-bottom: 10px; margin-top: 20px">
          <button
            class="margin"
            type="button"
            pButton
            label="Download Log"
            (click)="download()"
            style="float: right"
          ></button>
        </div>
        <div>
          <h3 *ngIf="activeJobLog != undefined">
            <u>Job Name</u> :
            <small> {{ activeJobLog.jobName }} </small>&emsp;&emsp;&emsp;<u
              >Job User</u
            >
            :
            <small>{{ this.activeJobLog.jobUser }} </small>&emsp;&emsp;&emsp;<u
              >Job Number</u
            >
            :
            <small>{{ this.activeJobLog.jobNumber }} </small>
          </h3>
        </div>
        <div *ngIf="joblogs != undefined">
          <div
            class="container-all"
            *ngFor="let joblog of joblogs"
            style="
              line-height: 1;
              font-family: 'Courier New', Courier, monospace;
            "
          >
            <span
              style="
                margin-left: 2px;
                white-space: pre-line;
                line-height: 0.9;
                font-family: 'Courier New', Courier, monospace;
              "
            >
              {{ joblog.messageText }}
            </span>
            <span
              style="
                margin-left: 25px;
                white-space: pre-line;
                line-height: 0.9;
                font-family: 'Courier New', Courier, monospace;
              "
            >
              <div
                style="
                  margin-left: 25px;
                  font-family: 'Courier New', Courier, monospace;
                "
              >
                {{ joblog.messageSecondLevelText }}
              </div>
            </span>
          </div>
        </div>
      </div>
    </div>
  </p-dialog>
</div>

